import React, { Component, PropTypes } from 'react';

export default class FormFitterDecorator extends Component {
	static propTypes = {
		className: PropTypes.string,
	};

	static defaultProps = {
		className: '',
	};

	render() {
		let className = 'account-block-content__default__section';

		if (this.props.className) {
			className += ' ' + this.props.className;
		} else {
			className += ' span3 span5-tablet span11-mobile';
		}

		return (
			<div className='account-block-content__default'>
				<div className={className}>

					{this.props.children}

				</div>
			</div>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/decorators/formfitter.js
 **/